export let BuzzUserGroup = /*#__PURE__*/function (BuzzUserGroup) {
  BuzzUserGroup["Buzz"] = "Buzz";
  BuzzUserGroup["LightyearAdmin"] = "Lightyear Admin";
  return BuzzUserGroup;
}({});